import React from "react";
import AsignarNovedad from "../components/Novedades/AsignarNovedad";

const AsignarTipoDeNovedadPage = () => {
  return <AsignarNovedad />;
};

export default AsignarTipoDeNovedadPage;
